import { StatsType } from '../config/stats';
import { IStatPassConditionContext } from '../context/app';
import { HistoricalStatsValue } from '../models/HistoricalStats';
import { countLateGoals } from './lateGoals';

export interface IStatPassCondition {
  matchStats: HistoricalStatsValue;
  statName: StatsType;
  statsCondition: IStatPassConditionContext;
}

export interface CalculateHistoryUnderOver {
  condition: number;
  isOver: boolean;
  value: number;
}

const calculateOverUnderStats = ({ value, condition, isOver }: CalculateHistoryUnderOver) => {
  if (isOver) {
    return value > condition;
  }
  return value < condition;
};

export const getStatsDetails = (statName: string): [string, string] => {
  const [type, stats] = statName.split('.');
  return [type, stats];
};

export const isStatPassCondition = ({ matchStats, statName, statsCondition }: IStatPassCondition) => {
  if (!statsCondition) return false;

  const { result, home, away } = matchStats;
  const [type, stats] = getStatsDetails(statName);
  if (statsCondition?.isOverStats) {
    if (stats === 'under' || stats === 'over') {
      const { isOver, condition } = statsCondition;
      return calculateOverUnderStats({ value: result, condition, isOver });
    }

    return false;
  }

  if (type === 'breaker') {
    if (Array.isArray(home) && Array.isArray(away)) {
      const [homeHT, homeFT] = home;
      const [awayHT, awayFT] = away;

      if (homeFT === awayFT || homeHT === awayHT) {
        return false;
      }
      const firstHalfWinner = homeHT > awayHT ? 'home' : 'away';
      const secondHalfWinner = homeFT > awayFT ? 'home' : 'away';

      if (firstHalfWinner !== secondHalfWinner) {
        return true;
      }

      return false;
    }

    return false;
  }

  if (type === 'goal') {
    if (matchStats.statType === 'late') {
      const goalEventsHome = matchStats.home.filter((event) => event.type === 'Goal');
      const goalEventsAway = matchStats.away.filter((event) => event.type === 'Goal');

      const homeLateGoal = goalEventsHome.filter(countLateGoals);
      const awayLateGoal = goalEventsAway.filter(countLateGoals);

      return homeLateGoal.length > 0 || awayLateGoal.length > 0;
    }

    if (stats === 'btts') {
      return home > 0 && away > 0;
    }

    if (stats === 'noBtts') {
      return home === 0 || away === 0;
    }

    if (stats === 'bttsAndMoreThanHalfTwo') {
      return home > 0 && away > 0 && result > 2;
    }

    if (stats === 'bttsAndMoreThanHalfThree') {
      return home > 0 && away > 0 && result > 3;
    }

    if (stats === 'draws') {
      return home === away;
    }

    if (stats === 'noDraws') {
      return home !== away;
    }
  }

  if (type === 'card') {
    if (stats === 'redCard') {
      return result > 0;
    }

    if (stats === 'noRedCard') {
      return result === 0;
    }
  }
};
